export default {
  selectedTechBusiness: state => state.selectedTechBusiness,
  selectedTechnician: state => state.selectedTechnician,
  techBusiness: state => state.techBusiness,
  techBusinesses: state => state.techBusinesses
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/getters.js